import { jsx as _jsx } from "react/jsx-runtime";
import { usePublishEnvironment } from '../../../r3f/environment/WorldEnvironmentScope';
import { usePublishCameraAttributes } from '../../../r3f/environment/worldExposure';
import { useResolvedCameraAttributes } from '../../../r3f/environment/useResolvedCameraAttributes';
import { useResolvedEnvironment } from './useResolvedEnvironment';
export function WorldEnvironment({ node, children }) {
    const properties = node.properties;
    usePublishEnvironment(useResolvedEnvironment(properties.environment));
    usePublishCameraAttributes(useResolvedCameraAttributes(properties.camera_attributes));
    return _jsx("group", { name: node.name, children: children });
}
//# sourceMappingURL=Component.js.map